import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  projectId: "juridico-internacional-mvp",
  appId: "1:952862795951:web:4540487f118d10a5208c5a",
  storageBucket: "juridico-internacional-mvp.firebasestorage.app",
  apiKey: "AIzaSyAEaiCslREUn1EbXlYFs-5XIKPReJ6eUOo",
  authDomain: "juridico-internacional-mvp.firebaseapp.com",
  messagingSenderId: "952862795951",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
